import React, { useState, useEffect } from "react";

// Externals
import cn from "classnames";

// DevExtreme components
import { Toolbar, Item } from 'devextreme-react/toolbar';

// Component styles
import classes from "./MultiInstanceNavigationWidget.module.scss";

export function MultiInstanceNavigationWidget(props) {
  const { ui, data, config, doAction } = props;
  const [localSelectContent, setLocalSelectContent] = useState();

  let widgetId = ui.id;
  let buttons = config ? config.Buttons : null;
  let content = data ? JSON.parse(data.content) : null;
  let selectContent = localSelectContent ? localSelectContent : content ? content.CurrentItem : "";

  let disabledByUi = ui.readonly;
  let disabledByData = data && data.readonly;
  let disabledToolbar = disabledByUi || disabledByData;

  useEffect(() => {
    //console.log("MultiInstanceNavigationWidget data of " + ui.id + ": ", data);
    setLocalSelectContent();
  }, [data]);

  const onButtonClick = async (event, actionId) => {
    doAction(actionId);
  };

  const setContent = value => {
    setLocalSelectContent(value);
    doAction("SELECT", value);
  };

  const findIcon = actionId => {
    switch (actionId) {
      case "NEW":
        return "plus";
      case "DELETE":
        return "close";
      case "PREV":
        return "chevronleft";
      case "NEXT":
        return "chevronright";
      case "FIRST":
        return "chevrondoubleleft";
      case "LAST":
        return "chevrondoubleright";
      default:
        return null;
    }
  };

  const isControlEnabled = actionId => {
    if (disabledToolbar) return false;
    if (content && content.EnabledButtons) {
      return content.EnabledButtons.includes(actionId);
    }
    return false;
  };

  const isSelect = actionId => {
    return actionId === "SELECT";
  };

  const renderSelectBox = (control) => {
    return (
      <Item
        key={control.ActionId}
        widget="dxSelectBox"
        location="before"
        disabled={!isControlEnabled(control.ActionId)}
        options={{
          hint: control.Tooltip,
          value: selectContent,
          items: content.Candidates,
          displayExpr: "DisplayData",
          valueExpr: "ItemId",
          placeholder: "",
          onValueChanged: (e) => setContent(e.value),
          height: "1.9em"
        }}
      />
    );
  };

  const renderActionButton = (control) => {
    return (
      <Item
        key={control.ActionId}
        widget="dxButton"
        location="before"
        disabled={!isControlEnabled(control.ActionId)}
        options={{
          icon: findIcon(control.ActionId),
          hint: control.Tooltip,
          stylingMode: "text",
          onClick: e => onButtonClick(e, control.ActionId)
        }}
      />
    );
  };

  return config
    ? (
      <Toolbar
        className={cn(classes.navigationToolbar, "dx-theme-border-color")}
        id={widgetId}
        style={{height: ui.controlHeight + "em"}}
      >
        {buttons.map(control => (
          isSelect(control.ActionId)
            ? renderSelectBox(control)
            : renderActionButton(control)
        ))}
      </Toolbar>
    )
    : null;
}